module.exports = __webpack_public_path__ + "static/img/buy_text.247edd6b.png";